import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Entry from "@/pages/Entry";
import Residential from "@/pages/Residential";
import Commercial from "@/pages/Commercial";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import ProjectDetail from "@/pages/ProjectDetail";
import Projects from "@/pages/Projects";
import ClientPortal from "@/pages/ClientPortal";
import TimeClock from "@/pages/TimeClock";
import ProposalView from "@/pages/ProposalView";
import ReviewProposal from "@/pages/ReviewProposal";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-background min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Entry />} />
          <Route path="/residential" element={<Residential />} />
          <Route path="/commercial" element={<Commercial />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/portal/:token" element={<ClientPortal />} />
          <Route path="/time" element={<TimeClock />} />
          <Route path="/project/:id" element={<ProjectDetail />} />
          <Route path="/proposal/:id" element={<ProposalView />} />
          <Route path="/review-proposal" element={<ReviewProposal />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" />
    </div>
  );
}

export default App;
